// @flow
import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link, withRouter } from 'react-router-dom';
import { Col, Card } from 'reactstrap';

import Pixel from '../../utils/Pixel';

import { connect } from 'react-redux';

import { searchState } from '../../actions/productAction';
import { useScrollMemory } from '../../helpers/dom';

/*
type DocumentHtml = ?HTMLElement;

type IsTouchDeviceHtml = ?boolean;

type UpdateActiveIdFunction = (id: number) => void

type OnClickFunction = (e: Event) => void
*/

const myDocumentElement = document.documentElement;

const isTouchDevice = myDocumentElement && 'ontouchstart' in myDocumentElement;

/*
type Props = {
  id: number, //current product variant ID
  activeId: number, //previously selected product variant ID
  updateActiveId: UpdateActiveIdFunction,
  url: string,
  title?: string,
  children?: Array<React$Node>,
}

type SneakerLinkProps = {
  href: string,
  title?: string,
  onClick?: OnClickFunction,
  children?: Array<React$Node>
}
*/

const SneakerLink = (props) => {
  const {
    children,
    href,
    onClick,
    productPrice,
    search,
    isCollectionPage,
    collection_id,
  } = props;

  const [_search, set_Search] = useState(search);

  useEffect(() => {
    set_Search(search);
    if (isCollectionPage) {
      set_Search(`${search}&collection_id=${collection_id}`);
    }
  }, [search, isCollectionPage]);

  useScrollMemory();

  return (
    // <a {...rest}>
    <Link
      to={{
        pathname: href,
        state: { price: productPrice },
        search: _search,
      }}
    >
      <Card className="wrapper grey-default">{children}</Card>
    </Link>
    // </a>
  );
};

function SneakerCard(props) {
  const {
    id,
    activeId,
    updateActiveId,
    url,
    title,
    children,
    similarProducts,
    query,
    isCollectionPage,
    collection_id,
  } = props;
  const onclick = (e, id) => {
    if (similarProducts) {
      props.searchState('');
    }

    //TODO: consider touch laptops that may register as touch devices but we want hover
    if (isTouchDevice && id !== activeId) {
      updateActiveId(id);
      // Prevent navigation
      e.preventDefault();
    }
  };

  return (
    <Col xs={6} sm={6} md={4} lg={3} className="sneaker">
      <SneakerLink
        collection_id={collection_id}
        isCollectionPage={isCollectionPage}
        href={url}
        title={title}
        onClick={(e) => onclick(e, id)}
        search={query}
      >
        {children}
      </SneakerLink>
    </Col>
  );
}

const mapStateToProps = (state) => ({
  searchKeyword: state.dataProduct.searchKeyword,
});

const mapDispatchToProps = (dispatch) => ({
  searchState: (payload) => dispatch(searchState(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SneakerCard));
